import { Component, ContentChild, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { setTimeout$ } from 'src/app/core/common';
import { KarpashaService } from 'src/app/services/karpasha.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-karpasha-payment',
  templateUrl: './karpasha-payment.component.html',
  styleUrls: ['./karpasha-payment.component.scss']
})
export class PaymentComponent implements OnInit {
  constructor(private userService: UserService, private karpashaService: KarpashaService, private spinner: SpinnerService) { }

  async ngOnInit() {
    if (this.payButton?.nativeElement)
      this.payButton.nativeElement.onclick = async () => {
        switch (this.type) {
          case 'agent-registration':
          case 'agent-service':
            this.paymentModal.open();
            break;
          case 'karyar':
            await this.userService.payKaryar(this.amount);
            break;
        }
      }
  }

  @ViewChild('paymentModal') paymentModal: NgxSmartModalComponent;
  @ViewChild('paymentHelpModal') paymentHelpModal: NgxSmartModalComponent;

  @ContentChild('payButton', { static: true }) payButton: ElementRef;
  @Input() amount: number;
  @Input() type = 'agent-registration';
  @Input() data: any = {};

  @Output() startPay = new EventEmitter();
  
  @Output() canceled = new EventEmitter();

  showOfflinePayment = true;
  async pay(manualToken?: string) {
    this.spinner.show('payment');
    setTimeout$(() => this.startPay.emit());
    switch (this.type) {
      case 'agent-registration':
        await this.userService.payAgentRegistration(manualToken);
        break;
      case 'agent-service':
        await this.karpashaService.paySeekerJobPayment(this.data.seekerJobId, manualToken);
        break;
    }
  }

  paymentLink: string;
  async makePayment() {
    this.paymentModal.close();
    this.spinner.show('payment');
    switch (this.type) {
      case 'agent-registration':
        this.paymentLink = (await this.userService.makeAgentRegistrationPayment()).link;
        break;
      case 'agent-service':
        this.paymentLink = (await this.karpashaService.makeSeekerJobPayment(this.data.seekerJobId)).link;
        break;
    }
    if (this.paymentLink)
      this.paymentHelpModal.open();
    this.spinner.hide('payment');
  }
}
